import { ContainersStateInterface } from '../../models';

export const ContainersInitialState: ContainersStateInterface = {
  containers: [],
  hasLoaded: false,
  isLoading: false,
  error: null
};
